import { ApplicantProfileTab } from '../../../../../store/workspace/types';
import { useDispatch, useSelector } from '../../../../../store/store';
import { ProfileSquareIcon } from '../../../../../assets/icons';
import { applicantProfileTabs } from '../../../../../configs';
import Spinner from '../../../../../components/Spinner';
import PersonalInformation from './PersonalInformation';
import Button from '../../../../../components/Button';
import { PDFDownloadLink } from "@react-pdf/renderer";
import Modal from '../../../../../components/Modal';
import WorkExperience from './WorkExperience';
import UploadedFiles from './UploadedFiles';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import Identifying from './Identifying';
import ResumePDF from "./ResumePDF";
import Expertise from './Expertise';
import Education from './Education';
import {
    selectExaminerProfile,
    selecFetchingExaminerProfile,
} from '../../../../../store/workspace/selectors';
import {
    setExaminerProfile,
    setExaminerProfileModal,
} from '../../../../../store/workspace/slice';

export default function ApplicantProfile() {
    const dispatch = useDispatch();
    const profile = useSelector(selectExaminerProfile);
    const fetching = useSelector(selecFetchingExaminerProfile);
    const [tab, setTab] = useState<ApplicantProfileTab>('Personal');

    useEffect(() => {
        return () => {
            dispatch(setExaminerProfile(null));
        }
    }, []);

    return (
        <Modal
            size='xxl'
            icon={<ProfileSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setExaminerProfileModal(false))}
            title={`${profile ? `${profile?.firstName} ${profile?.lastName}` : 'Applicant'} - Information`}
        >
            {fetching ? <div className={styles.loading}>
                <Spinner />
            </div> : <>
                <div className={styles.tabs}>
                    {applicantProfileTabs.map(i => <span
                        className={styles.tab}
                        onClick={() => setTab(i.id)}
                        data-tab-active={tab === i.id}
                    >
                        {i.title}
                    </span>)}
                </div>
                <div className={styles.content}>
                    {tab === 'Expertise' && <Expertise data={profile?.experties} />}
                    {tab === 'Education' && <Education data={profile?.educationInfo} />}
                    {tab === 'WorkExperience' && <WorkExperience data={profile?.workExperience} />}
                    {tab === 'Identify' && <Identifying avatar={profile?.profilePhoto} kycStatus={profile?.kyc || ''} />}

                    {tab === 'Personal' && <PersonalInformation
                        data={profile}
                        salary={profile?.desiredAnnualSalaryRange}
                        visaStatus={profile?.requireSponsorshipVisa}
                    />}

                    {tab === 'Files' && <UploadedFiles
                        resumeFileKey={profile?.resumeFileKey}
                        portfolioFileKey={profile?.portfolioFileKey}
                        resumeFileKeyLink={profile?.resumeFileKeyLink}
                        certificateFileKey={profile?.certificateFileKey}
                        coverLetterFileKey={profile?.coverLetterFileKey}
                        portfolioFileKeyLink={profile?.portfolioFileKeyLink}
                        certificateFileKeyLink={profile?.certificateFileKeyLink}
                        coverLetterFileKeyLink={profile?.coverLetterFileKeyLink}
                    />}
                </div>
                <div className={styles.actions}>
                    <Button
                        text='Close'
                        type='Outline-Dark'
                        className={styles.actions_btn}
                        onClick={() => dispatch(setExaminerProfileModal(false))}
                    />
                    {profile && <PDFDownloadLink
                        className={styles.actions_link}
                        document={<ResumePDF data={profile} />}
                        fileName={`${profile?.firstName}-${profile?.lastName}.pdf`}
                    >
                        {({ loading }) => (loading ? "Generating PDF..." : "Download Applicant Profile")}
                    </PDFDownloadLink>}
                </div>
            </>}
        </Modal>
    )
}
